import React, { useEffect, useState } from "react";
import { Alert, Descriptions, Form, Input, Modal, Tag } from "antd";

const { TextArea } = Input;

const VoidPaymentModal = ({ visible, payment, onCancel, onConfirm }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (visible) form.resetFields();
  }, [visible, form]);

  const handleConfirm = async () => {
    try {
      const { reason } = await form.validateFields();
      setSubmitting(true);
      await onConfirm(reason);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Void Manual Payment"
      open={visible}
      onCancel={onCancel}
      onOk={handleConfirm}
      okText="Void and reverse payment"
      okButtonProps={{ danger: true }}
      confirmLoading={submitting}
      destroyOnClose
    >
      <Alert
        type="warning"
        showIcon
        message="This will reverse the amount everywhere it was applied. The payment record will remain for audit purposes."
        style={{ marginBottom: 16 }}
      />
      {payment && (
        <Descriptions
          column={1}
          bordered
          size="small"
          style={{ marginBottom: 16 }}
        >
          <Descriptions.Item label="Reference">
            {payment.paymentReference}
          </Descriptions.Item>
          <Descriptions.Item label="Student">
            {payment.studentName || "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Amount">
            {Number(payment.amount || 0).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag>{payment.status}</Tag>
          </Descriptions.Item>
        </Descriptions>
      )}
      <Form form={form} layout="vertical">
        <Form.Item
          name="reason"
          label="Reason for voiding"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "Please provide a reason",
            },
            { max: 500, message: "Reason cannot exceed 500 characters" },
          ]}
        >
          <TextArea
            rows={3}
            placeholder="Example: Manual payment entered in error; reversal requested by the school"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default VoidPaymentModal;
